import * as audio from './kernel/audio.js';
import * as main from './main.js';

export {
    init,
    status,
    showStart,
}

let testHeadphone;

function init() {
    document.querySelector('.js-start').addEventListener('click', () => {
        if (DEVMODE) console.log('Starting...');
        document.querySelector('.headphone').classList.add('hidden');
        document.querySelector('.js-start').classList.add('hidden');
        document.querySelector('.center').classList.add('hidden');
        document.querySelector('.screen').classList.remove('hidden');
        audio.resume().then(() => {
            if (testHeadphone) testHeadphone.fade(1);
            main.start();
        });
    });

    document.querySelector('.js-test-headphone').addEventListener('click', testHeadphones);
}

function status(status) {
    const statusEl = document.querySelector('#status');
    if (status === null) statusEl.classList.add('hidden');
    else statusEl.classList.remove('hidden');
    statusEl.innerText = status;
}

function showStart() {
    document.querySelector('.headphone').classList.remove('hidden');
    document.querySelector('.js-start').classList.remove('hidden');
    status(null);
}

function testHeadphones() {
    const leftIndicator = document.querySelector('.test-headphone-left');
    const rightIndicator = document.querySelector('.test-headphone-right');
    
    audio.resume().then(() => {
        testHeadphone = audio.buffers.play('test-headphone', {
            onended: () => {
                rightIndicator.style.opacity = 0;
            }
        });
    });

    leftIndicator.style.opacity = 1;
    setTimeout(() => {
        leftIndicator.style.opacity = 0;
        rightIndicator.style.opacity = 1;
    }, 8000);
}